export default __webpack_public_path__ + "static/media/hht2_ep06_book_wp_01.2200f860.jpg";